// 顶部状态条：A股状态 + 事件源健康度 + 最后刷新
import { useEffect } from 'react';
import { Tag, Space, Tooltip } from 'antd';
import {
  ClockCircleOutlined,
  RiseOutlined,
  PauseCircleOutlined,
  GlobalOutlined,
  CheckCircleFilled,
  WarningFilled,
  CloseCircleFilled,
} from '@ant-design/icons';
import { useStore } from '../store/account';
function HealthBadge({
  status,
  lastError,
}: {
  status: 'ok' | 'slow' | 'offline';
  lastError: string | null;
}) {
  if (status === 'ok') {
    return (
      <Tooltip title="事件源正常">
        {' '}
        <Tag icon={<CheckCircleFilled />} color="success">
          {' '}
          事件源 ✅ 正常{' '}
        </Tag>{' '}
      </Tooltip>
    );
  }
  if (status === 'slow') {
    return (
      <Tooltip title={lastError ?? '事件源响应较慢'}>
        {' '}
        <Tag icon={<WarningFilled />} color="warning">
          {' '}
          事件源 ⚠️ 延迟{' '}
        </Tag>{' '}
      </Tooltip>
    );
  }
  return (
    <Tooltip title={lastError ?? '事件源离线，黑哥们事件可能不会自动触发'}>
      {' '}
      <Tag icon={<CloseCircleFilled />} color="error">
        {' '}
        事件源 ❌ 离线{' '}
      </Tag>{' '}
    </Tooltip>
  );
}
export default function MarketStatusBar() {
  const { marketStatus, lastUpdate, startTicker, newsHealth, refreshNewsHealth } = useStore();
  useEffect(() => {
    const stop = startTicker(10000);
    refreshNewsHealth();

    // 健康度单独每 30 秒刷新一次（降低资源消耗）
    const id = setInterval(refreshNewsHealth, 30_000);
    return () => {
      stop();
      clearInterval(id);
    };
  }, [startTicker, refreshNewsHealth]);
  const lastUpdateStr = lastUpdate
    ? new Date(lastUpdate).toLocaleTimeString('zh-CN', { hour12: false })
    : '未刷新';
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '6px 16px',
        background: '#161b22',
        borderBottom: '1px solid #30363d',
        fontSize: 12,
        color: '#8b949e',
        gap: 8,
        flexWrap: 'wrap',
      }}
    >
      {' '}
      <Space size="middle" wrap>
        {' '}
        {marketStatus?.isOpen ? (
          <Tag icon={<RiseOutlined />} color="success">
            {' '}
            A 股交易中{' '}
          </Tag>
        ) : (
          <Tooltip title={marketStatus?.label}>
            {' '}
            <Tag icon={<PauseCircleOutlined />} color="default">
              {' '}
              A 股{marketStatus?.label ?? '加载中...'}{' '}
            </Tag>{' '}
          </Tooltip>
        )}{' '}
        <Tag color="processing">虚拟货币 24h</Tag>{' '}
        <HealthBadge status={newsHealth.status} lastError={newsHealth.lastErrorMessage} />{' '}
      </Space>{' '}
      <Space>
        {' '}
        <GlobalOutlined /> <span>最后刷新: {lastUpdateStr}</span>{' '}
      </Space>{' '}
    </div>
  );
}
